import useAxios from '../../config/RequestInterceptor';
import {useQuery} from "react-query";

interface BusinessProps {
    member_id: number
}

const time = {
    staleTime: 60 * 1000 * 10,
    cacheTime: 60 * 1000 * 10
};


let valueData: BusinessProps | null = null;

const getBusinessByUser = async () => {
    // @ts-ignore
    // const queryString = Object.keys(valueData)
    //     // @ts-ignore
    //     .map((key) => key + '=' + valueData[key])
    //     .join('&');

    // return await useAxios.get(`/wp-json/jwt-auth/v1/business?${queryString}`).then(data => (data.data));
    // return await useAxios.get(`/api/businesses?filters[member_id][$eq]=${valueData?.member_id}`).then(data => (data.data));
    return await useAxios.get(`/api/user-business`).then(data => (data.data));
};

export const useGetBusinessByUser = (values: BusinessProps) => {
    valueData = values;
    return useQuery(['get-business-by-user', values], getBusinessByUser, time)
}
